
/* injects from baggage-loader */
require('./style.styl');

import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import moment from 'moment'
import Icon from 'components/Icon'
import Link from 'components/Link'
import {integrationTypes} from 'redux/modules/integrations/selectors'
import get from 'lodash/get'
import Limit from 'containers/Limit'
import {channelGroups as groups} from '@divvit/common-channels'

export default class Integration extends Component {
  static propTypes = {
    connected: PropTypes.bool,
    expanded: PropTypes.bool,
    serviceId: PropTypes.string,
    integrationId: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
    costConfig: PropTypes.object,
    link: PropTypes.bool
  }

  static defaultProps = {
    costConfig: {}
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    const {integrationId, connected, expanded, serviceId, link, costConfig} = this.props
    const classNames = classnames('integration', `is-${serviceId}`, {
      'is-expanded': expanded,
      'is-connected': connected
    })

    if (link) {
      const {
        channel: {channelGroupId, channelId}
      } = costConfig
      return (
        <Link className={classNames} to={`/settings/channels/${channelGroupId}/${channelId}/${integrationId}`}>
          {this.renderIntegration()}
        </Link>
      )
    }

    return (
      <div className={classNames}>
        {this.renderIntegration()}
      </div>
    )
  }

  renderIntegration() {
    const {expanded, icon, children} = this.props

    return (
      <Fragment>
        <Icon
          className='integration_icon'
          name={icon}
          size='35px'
        />
        <div className='integration_text'>
          <div className='integration_title'>
            {this.renderTitle()}
          </div>
          <div className='integration_description'>
            {this.renderDescription()}
          </div>
          {expanded ? children : null}
        </div>
        {this.renderButton()}
      </Fragment>
    )
  }

  renderTitle() {
    const {title, link, costConfig} = this.props
    const {
      channel,
      name,
      api
    } = costConfig
    const {channelGroupId, channelId} = channel || {}
    const groupLabel = get(groups, `${channelGroupId}.label`, 'Unknown')
    const channelLabel = get(groups, `${channelGroupId}.channels.${channelId}.label`, 'Unknown')

    if (link && api) {
      return title
    } else if (link) {
      return name || `${groupLabel}/${channelLabel}`
    } else {
      return title
    }
  }

  renderButton() {
    const {connected, expanded, link, onClick} = this.props
    const buttonClassName = classnames('button integration_button', {
      'is-blue': !link && connected,
      'is-expanded': expanded,
      'is-closed': link || !expanded
    })
    const {permissions} = this.context

    if (link) {
      return (
        <div className={buttonClassName}>Show</div>
      )
    } else {
      return (
        <Limit
          className='analytics-view-menu_button'
          limitKey='costIntegration'
          action='read'
        >
          {permissions.read.includes('@features/costIntegration')
            ? <div className={buttonClassName} onClick={onClick}>
              {expanded ? (
                <Icon
                  className='integration_icon-close'
                  name={'arrow-dropdown'}
                  size='11px'
                />
              ) : (connected ? (
                <Icon
                  className='integration_icon-open'
                  name={'arrow-dropdown'}
                  size='11px'
                />
              ) : 'Connect')}
            </div>
            : <div className={buttonClassName}>
              {expanded ? (
                <Icon
                  className='integration_icon-close'
                  name={'arrow-dropdown'}
                  size='11px'
                />
              ) : (connected ? (
                <Icon
                  className='integration_icon-open'
                  name={'arrow-dropdown'}
                  size='11px'
                />
              ) : 'Connect')}
            </div>
          }
        </Limit>
      )
    }
  }

  renderDescription() {
    const {serviceId, connected, costConfig} = this.props

    if (!connected) return null

    const {
      integrationType,
      integrationStartDate,
      integrationEndDate
    } = costConfig

    if (serviceId === 'manual-input') {
      const startDate = moment(integrationStartDate).format('DD MMMM YYYY')
      const endDate = moment(integrationEndDate).format('DD MMMM YYYY')

      return (
        <Fragment>
          Connected | {integrationTypes[integrationType]} | From {startDate} to {endDate}
        </Fragment>
      )
    }

    return 'Connected'
  }
}



// WEBPACK FOOTER //
// ./client/components/Integration/index.js